<div class='div-body' *ngIf="showSpinner">
  <div class="loader-circle"></div>
</div>
